import { render, staticRenderFns } from "./Plating.vue?vue&type=template&id=10762e48&"
import script from "./Plating.vue?vue&type=script&lang=js&"
export * from "./Plating.vue?vue&type=script&lang=js&"
import style0 from "./Plating.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports